import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { URLS } from "fire-wind-water";
import { saveChannelParams } from "../stempcore/src/sbase";
Vue.config.productionTip = false;

import "./assets/scss/index.scss";
import "../stempcore/src/assets/scss/index.scss";

import Api from "./service/api";

// import VConsole from 'vconsole'
// new VConsole();
saveChannelParams();

//ios 浏览器返回不刷新
try {
  var browserRule = /^.*((iPhone)|(iPad)|(Safari))+.*$/;
  if (browserRule.test(navigator.userAgent)) {
    window.onpageshow = function (event) {
      if (event.persisted) {
        window.location.reload();
      }
    };
  }
} catch (ex) {
  console.log(ex);
}

window.$sk.Text.prototype.sendCode = function (key, o) {
  this.messages.sendCode = "请输入手机号";
  this.dirty = true;
  if (this.invalid) {
    return;
  }
  if (!this.value) {
    this.error.sendCode = true;
    this.hasError();
    return;
  }
  this.error.sendCode = false;
  this.sendCodeJson.time = 60;
  this.sendCodeJson.disabled = true;
  this.sendCallback(this);
  Api.sendCheckCode({
    globalUserId: window.$sk.template.get().user.globalUserId,
    mobile: this.value,
    questionaryId:
      URLS.getURL("questionaryId") || URLS.getHash("questionaryId"),
    ...o,
  }).subscribe((res) => {
    if (res.result !== 0) {
      window.$sk.alert(res.desc);
      this.sendCodeJson.time = 0;
      this.sendCodeJson.disabled = false;
      this.sendCallback(this);
    } else {
      this.sendWaiting();
    }
  });
};

import { SExtraFilter } from "../stempcore/src/core/sextra";
Vue.use(SExtraFilter);
import { SkFieldsComponents } from "../stempcore/src/core/sfield";
Vue.use(SkFieldsComponents);
import VueWechatTitle from "vue-wechat-title";
Vue.use(VueWechatTitle);
import { interact } from "fire-wind-water";
Vue.mixin({
  methods: {
    pxOrVw(value) {
      let newValue;
      if (interact.isMobile) {
        if (value > 2) {
          newValue = value / 7.5 + "vw";
        } else {
          newValue = "1px";
        }
      } else {
        newValue = value + "px";
      }
      return newValue;
    },
  },
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
